export default class DeclineSignerPayload {

    public reason: string | null = null;

}
